import Style from "css/point_css/point_d.module.css";
import {
  getPointList,
  getPointListCount,
  getPointListPrev,
} from "firebase_/firebase_function/point_function";
import { useEffect, useState } from "react";
import { formatNumberWithCommas } from "util/function/function";
import PointHistoryItem from "components/point/point_history_item";

import Pagenation from "components/pagenation";
import { useUser } from "util/context/user_context";
import OnlyLoadingPage from "components/loading_page";

const ExpertPointHistoryScreen = () => {
  const [pointList, setPointList] = useState([]); // 포인트 내역 상태
  const { userData } = useUser();
  const [totalData, setTotalData] = useState(0); // 전체 데이터 수 상태
  const [nowPointList, setNowPointList] = useState([]); // 현재 포인트 내역 상태
  const itemsPerPage = 5; // 페이지당 항목 수
  const [loading, setLoading] = useState(true); // 로딩 상태

  // 총 데이터 수 가져오기
  useEffect(() => {
    const fetchData = async () => {
      const totalCount = await getPointListCount(userData.id);
      setTotalData(totalCount);
    };
    fetchData();
  }, []);

  // 내 포인트 내역 가져오기
  const fetchData = async (date) => {
    const data = await getPointList(userData.id, itemsPerPage * 5, date);
    setPointList(data);
    return data;
  };

  // 내 포인트 이전 내역 가져오기
  const fetchDataPrev = async (date) => {
    const data = await getPointListPrev(userData.id, itemsPerPage * 5, date);
    setPointList(data);
    return data;
  };

  return (
    <>
      <div className={Style.container} style={{ padding: "20px", gap: "16px" }}>
        <div
          style={{
            display: "flex",
            gap: "6px",
            width: "100%",
            flexDirection: "column",
            background: "#ffffff",
            padding: "24px",
            boxSizing: "border-box",
            borderRadius: "16px",
            boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div className="f20_6B7280_W400">현재 포인트</div>
          <div
            className="f30_059669_W700"
            style={{ display: "flex", alignItems: "center", gap: "2px" }}
          >
            <div>{formatNumberWithCommas(userData["point"])}</div>
            <div style={{ fontSize: "18px" }}>P</div>
          </div>
        </div>
        {/* 포인트 내역 리스트 */}
        {loading ? (
          <>
            <OnlyLoadingPage />
          </>
        ) : (
          <>
            {nowPointList?.map((item, index) => (
              <>
                <PointHistoryItem key={index} item={item} />
              </>
            ))}
          </>
        )}

        <Pagenation
          totalData={totalData}
          HandleNextData={fetchData}
          HandlePrevData={fetchDataPrev}
          data={pointList}
          setSliceData={setNowPointList}
          setData={setPointList}
          itemsPerPage={itemsPerPage}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};

export default ExpertPointHistoryScreen;
